import merge from 'lodash/merge';
import config from '../../config';
import fetch, { toQueryString } from '../fetch';
import RestEntityAPI from './restEntityAPI';

const options = {
  entityName: 'jobCampaigns',
  endpoint: `${config.apiUrl}/v1/optimization`,
  campaign: `${config.apiUrl}/v1/optimization/campaign`,
  sponsorship: `${config.apiUrl}/v1/optimization/sponsorship`,
};

const JobCampaignsAPI = () => {
  const parentAPI = RestEntityAPI(options);

  const createSponsorship = async (organizationId, profileKey, body) => {
    const baseUrl = `${options.endpoint}/sponsorship${toQueryString(organizationId)}`;
    const headers = (profileKey !== null) ? { 'X-Profile-Key': profileKey } : { };

    try {
      const response = await fetch(baseUrl, {
        method: 'POST',
        headers,
        body: {
          data: body,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const getCampaigns = async (query, profileKey) => {
    const getUrl = `${options.endpoint}/campaign-list${toQueryString(query)}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};

    try {
      return await fetch(getUrl, { method: 'GET', headers });
    } catch (error) {
      throw error;
    }
  };

  const getSiteIds = async ({ query, profileKey, ctx }) => {
    const getUrl = `${options.campaign}/sites${toQueryString(query)}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
    try {
      return await fetch(getUrl, { method: 'GET', headers, ctx: ctx || {} });
    } catch (error) {
      throw error;
    }
  };

  const getNodes = async ({ orgId, profileKey, ctx }) => {
    const getUrl = `${options.endpoint}/organization/${orgId}/nodes`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
    try {
      return await fetch(getUrl, { method: 'GET', headers, ctx: ctx || {} });
    } catch (error) {
      throw error;
    }
  };

  const createCampaign = async ({ query, data, profileKey, ctx }) => {
    const getUrl = `${options.campaign}${toQueryString(query)}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
    try {
      return await fetch(getUrl, { method: 'POST', body: { data }, headers, ctx: ctx || {} });
    } catch (error) {
      throw error;
    }
  };

  const updateJobCampaign = async (campaignId, profileKey, organizationId, body) => {
    const baseUrl = `${options.endpoint}/campaign/${campaignId}${toQueryString(organizationId)}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
    try {
      const response = await fetch(baseUrl, {
        method: 'PATCH',
        headers,
        body: {
          data: body,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getSponsorships = async (query) => {
    const getUrl = `${options.campaign}/${query.campaign_id}/sponsorship-list${toQueryString({ ...query, is_history: false })}`;
    try {
      return await fetch(getUrl, {
        method: 'GET',
      });
    } catch (error) {
      throw error;
    }
  };

  const getSponsorshipsHistory = async (query) => {
    const getUrl = `${options.campaign}/${query.campaign_id}/sponsorship-list${toQueryString({ ...query, is_history: true })}`;
    try {
      return await fetch(getUrl, {
        method: 'GET',
      });
    } catch (error) {
      throw error;
    }
  };

  const getCampaign = async ({ campaignId, organizationId }) => {
    const getUrl = `${options.campaign}/${campaignId}${toQueryString({ organization_id: organizationId, get_sponsorship: true })}`;
    try {
      return await fetch(getUrl, {
        method: 'GET',
      });
    } catch (error) {
      throw error;
    }
  };

  const updateCampaign = async ({ campaignId, organizationId }, data = {}) => {
    const getUrl = `${options.campaign}/${campaignId}?organization_id=${organizationId}`;
    try {
      return await fetch(getUrl, {
        method: 'PATCH',
        body: { data },
      });
    } catch (error) {
      throw error;
    }
  };

  const updateCampaignSponsorship = async ({ sponsorshipId, data }, query, profileKey) => {
    try {
      const baseUrl = `${options.endpoint}/sponsorship/${sponsorshipId}${toQueryString(query)}`;
      const headers = (profileKey !== null) ? { 'X-Profile-Key': profileKey } : {};

      return await fetch(baseUrl, {
        method: 'PATCH',
        body: { data },
        headers,
      });
    } catch (error) {
      throw error;
    }
  };

  // const getCampaign = async (campaignId, profileKey, query) => {
  //   const baseUrl = `${options.endpoint}/campaign/${campaignId}${toQueryString(query)}`;
  //   const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
  //   try {
  //     const response = await fetch(baseUrl, {
  //       method: 'GET',
  //     });
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  return merge({}, { ...parentAPI }, {
    getCampaigns,
    getCampaign,
    getSponsorships,
    getSponsorshipsHistory,
    getSiteIds,
    getNodes,
    createCampaign,
    createSponsorship,
    updateJobCampaign,
    updateCampaign,
    updateCampaignSponsorship,
  });
};

export default JobCampaignsAPI;
